import n from"./global.js";import o from"./is-callable.js";var r=n,a=o,i=function(l){return a(l)?l:void 0},u=function(l,t){return arguments.length<2?i(r[l]):r[l]&&r[l][t]};export{u as default};
